'use client'

import Script from 'next/script'
import { IS_DEVELOPMENT } from '@/config/env'

export function ChatKitScriptLoader() {
	return (
		<Script
			src="https://cdn.platform.openai.com/deployments/chatkit/chatkit.js"
			strategy="afterInteractive"
			onLoad={() => {
				if (typeof globalThis.window !== 'undefined') {
					if (IS_DEVELOPMENT) {
						console.info('[ChatKitScriptLoader] Script loaded, checking custom element...')
					}
					setTimeout(() => {
						const hasElement = globalThis.customElements?.get('openai-chatkit')
						if (IS_DEVELOPMENT) {
							console.info('[ChatKitScriptLoader] Custom element check', {
								hasElement: Boolean(hasElement),
								customElementsAvailable: Boolean(globalThis.customElements),
							})
						}
						globalThis.dispatchEvent(new CustomEvent('chatkit-script-loaded'))
					}, 100)
				}
			}}
			onError={(e) => {
				console.error('[ChatKitScriptLoader] Script load error', e)
				if (typeof globalThis.window !== 'undefined') {
					globalThis.dispatchEvent(
						new CustomEvent('chatkit-script-error', {
							detail: e instanceof Error ? e.message : 'Failed to load ChatKit script',
						}),
					)
				}
			}}
		/>
	)
}
